import { h, render } from 'preact';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'up-ops-web-shared-components';
import App from './App';
import './i18n';
import './index.scss';
import { makeServer } from './mockServer';
import { store } from './store';
import { APP_ENV } from './utils/constants';

if (APP_ENV === 'development') {
  makeServer({ environment: 'development' });
}

render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')!,
);
